import { render, staticRenderFns } from "./OpenReviewsNotification.vue?vue&type=template&id=58b39940&"
import script from "./OpenReviewsNotification.vue?vue&type=script&lang=js&"
export * from "./OpenReviewsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports